import React from 'react';
import { NavLink } from 'react-router-dom';
import { connect } from 'react-redux';

class IngredientName extends React.Component {

  render() {

    const {machine_name, ingredients, linkToIngredient, secondLast, last} = this.props;

    // BEGIN
    const isIngredient = p => p.machine_name === machine_name
    const ingredient = ingredients.items.find(isIngredient)
    // END

    if (!ingredient) {
      return <strong>The ingredient {machine_name} is missing.</strong>
    }

    let ingredientRendered = (
      <span style={{fontWeight: 'bold'}}>
        <em> {ingredient.name}</em>
        {!last && !secondLast &&
        <span>,</span>
        }
        {secondLast &&
        <span> and</span>
        }
      </span>
    )

    if (linkToIngredient) {
      return (
        <NavLink to={`/ingredient/${ingredient.machine_name}`}>
          {ingredientRendered}
        </NavLink>
      )
    }

    return ingredientRendered;
  }
}

const connectedIngredientName = connect(null)(IngredientName);
export { connectedIngredientName as IngredientName };


// WEBPACK FOOTER //
// ./src/IngredientName/IngredientName.jsx